<template>
  <div style="width: 100%;">
    <b-col cols="12">
      <div class="divider divider-solid">
        <div
          class="divider-text"
          style="font-weight: 600;"
        >
          Seo
        </div>
      </div>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaTitle"
        label-for="MetaTitle"
      >
        <b-form-input
          id="MetaTitle"
          :value="localForm.MetaTitle"
          name="MetaTitle"
          autocomplete="off"
          @input="updateField('MetaTitle', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="ImageAlt"
        label-for="ImageAlt"
      >
        <b-form-input
          id="ImageAlt"
          :value="localForm.ImageAlt"
          name="ImageAlt"
          autocomplete="off"
          @input="updateField('ImageAlt', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaDescription"
        label-for="MetaDescription"
      >
        <b-form-input
          id="MetaDescription"
          :value="localForm.MetaDescription"
          name="MetaDescription"
          autocomplete="off"
          @input="updateField('MetaDescription', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaKeywords"
        label-for="MetaKeywords"
      >
        <b-form-input
          id="MetaKeywords"
          :value="localForm.MetaKeywords"
          name="MetaKeywords"
          autocomplete="off"
          @input="updateField('MetaKeywords', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="ویدئو"
        label-for="Video"
      >
        <b-form-file
          id="Video"
          accept="video/*"
          placeholder="انتخاب فایل ویدئو..."
          drop-placeholder="فایل را اینجا رها کنید..."
          browse-text="انتخاب"
          @input="onVideoChange"
        />

        <div
          v-if="videoPreview"
          class="mt-1"
        >
          <video
            :src="videoPreview"
            controls
            preload="metadata"
            style="width: 100%; max-height: 300px; border-radius: 8px; background: #000;"
          />
        </div>
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'ZSeo',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localForm: { ...this.value },
      videoObjectUrl: null,
    }
  },
  computed: {
    videoPreview() {
      // فایل تازه انتخاب‌شده اولویت دارد، در غیر این صورت آدرس ویدئوی ذخیره‌شده
      if (this.videoObjectUrl) {
        return this.videoObjectUrl
      }

      return typeof this.localForm.Video === 'string' ? this.localForm.Video : null
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localForm = { ...newVal }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.videoObjectUrl) {
      URL.revokeObjectURL(this.videoObjectUrl)
    }
  },
  methods: {
    updateField(field, value) {
      this.localForm[field] = value
      this.$emit('input', { ...this.localForm })
    },
    onVideoChange(file) {
      if (this.videoObjectUrl) {
        URL.revokeObjectURL(this.videoObjectUrl)
        this.videoObjectUrl = null
      }

      if (file instanceof File) {
        this.videoObjectUrl = URL.createObjectURL(file)
        this.updateField('Video', file)
      } else {
        this.updateField('Video', null)
      }
    },
  },
}
</script>
